import { IUserState, EUserTariffType } from '../../types/reducers/user';
import { getUserTariffs } from './getUserTariffs';

export interface IUserTariff {
  isNonCommercial: boolean;
  isBase: boolean;
  isPro: boolean;
  isBuilder: boolean;
}

export const getUserTariff = (user: IUserState) => {
  const tariffs = getUserTariffs(user);

  return {
    isNonCommercial: tariffs.length === 0 || tariffs.includes(EUserTariffType.NonCommercial),
    isBase: tariffs.includes(EUserTariffType.Base),
    isPro: tariffs.includes(EUserTariffType.Pro),
    isBuilder: tariffs.includes(EUserTariffType.Builder),
  };
};
